import { cores, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomThemeProvider } from "../../Styles/theme/customThemeprovider";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { func_print } from "../../Func_genericas/func_print";
import { del, get } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { Snackbar } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { loader } from "../../Func_genericas/loader";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { Alert } from "../../Components/Alert/Alert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IChecklistItemSchema, IOperacaoAgricola, IOperacaoMaquinaSchema, IOperacaoTrabalhadorSchema } from "../../Interfaces/atividade/atividade";
import { IPlanoERPSchema } from "../../Interfaces/financeiro/financeiro";
import { Modaladdatividade } from "./add_atividade";
import { Modalveratividade } from "./ver_atividade";
import { Modalverlistatrabalhador } from "./ver_lista_trabalhadores";
import { ITrabalhador } from "../../Interfaces/maoobra/maoobra";
import { Modalverlistamaquina } from "./ver_lista_maquinas";
import { IMaquina } from "../../Interfaces/equipamentos/equipamentos";
import { Modalverlistachecklist } from "./ver_lista_checklist";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        // margin: theme.spacing(1),
        // width: theme.spacing(16),
        // height: theme.spacing(16),
        // minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "#7e2706",
    },
    picker: {
      color: "#7e2706",
      "&.Mui-checked": {
        color: "#ccafa3",
      },
    },
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: cores.cor1,
        height: 3,
      },
      "& .MuiTab-root.Mui-selected": {
        color: cores.cor1,
      },
    },
  })
);
function Atividade() {

  const classes = useStyles();

  const auth = useContext(AuthContext);
  const location = useLocation();


  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [openSnackSuccess, setOpenSnackSuccess] = useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [open_dialog_tem_a_certeza_que_quer_eliminar_atividade, set_open_dialog_tem_a_certeza_que_quer_eliminar_atividade] = useState<boolean>(false);

  const [flag_open_modal_atividade, set_flag_open_modal_atividade] = useState<boolean>(false);
  const [flag_open_modal_atividade_edit, set_flag_open_modal_atividade_edit] = useState<boolean>(false);
  const [flag_open_modal_atividade_add, set_flag_open_modal_atividade_add] = useState<boolean>(false);
  const [flag_open_modal_atividade_ver_mais, set_flag_open_modal_atividade_ver_mais] = useState<boolean>(false);
  const [obj_new_atividade, set_obj_new_atividade] = useState<IOperacaoAgricola>();
  const [lista_de_atividade, set_lista_de_atividade] = useState<IOperacaoAgricola[]>([]);

  const [lista_de_financeiro, set_lista_de_financeiro] = useState<IPlanoERPSchema[]>([]);

  const [lista_de_trabalhadores_aux, set_lista_de_trabalhadores_aux] = useState<ITrabalhador[]>([]);
  const [lista_de_trabalhadores, set_lista_de_trabalhadores] = useState<IOperacaoTrabalhadorSchema[]>([]);
  const [lista_de_maquinas, set_lista_de_maquinas] = useState<IOperacaoMaquinaSchema[]>([]);
  const [lista_de_checklist, set_lista_de_checklist] = useState<IChecklistItemSchema[]>([]);

  const [flag_open_modal_trabalhadores, set_flag_open_modal_trabalhadores] = useState<boolean>(false);
  const [flag_open_modal_maquinas, set_flag_open_modal_maquinas] = useState<boolean>(false);
  const [flag_open_modal_checklist, set_flag_open_modal_checklist] = useState<boolean>(false);

  const [lista_de_maquinas_aux, set_lista_de_maquinas_aux] = useState<IMaquina[]>([]);

  const get_info = async () => {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, 'api/plano-erp/agri/' + location.state);
      let res_atividade = await get(auth.token.cookie_token, 'api/operacoes/agri/' + location.state);
      let res_trabalhadores = await get(auth.token.cookie_token, 'api/trabalhadores/all/' + location.state);
      let res_maquinas = await get(auth.token.cookie_token, '/api/maquinas/all/' + location.state);



      if (res.status === 200) {
        set_lista_de_financeiro(res.data.result);
      } else {
        func_print("get_info", res.data, true);
      }
      if (res_atividade.status === 200) {
        set_lista_de_atividade(res_atividade.data.result);
      } else {
        func_print("get_info", res_atividade.data, true);
      }
      if (res_trabalhadores.status === 200) {
        set_lista_de_trabalhadores_aux(res_trabalhadores.data.result);
      } else {
        func_print("get_info", res_trabalhadores.data, true);
      }
      if (res_maquinas.status === 200) {
        set_lista_de_maquinas_aux(res_maquinas.data.result);
      } else {
        func_print("get_info", res_maquinas.data, true);
      }

      setIsLoading(false);

    } catch (error) {
      func_print("get_info", error, true);
      setIsLoading(false);
    }
  }

  const get_info_operacoes = async (id: number) => {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, 'api/operacoes/' + id);

      if (res.status === 200) {
        return res.data.result;
      } else {
        func_print("get_info_operacoes", res.data, true);
        return undefined;
      }

    } catch (error) {
      func_print("get_info_operacoes", error, true);
      return undefined;
    } finally {
      setIsLoading(false);
    }
  }


  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);


  const handle_delete_atividade = async () => {
    try {
      setIsLoading(true);
      await del(auth.token.cookie_token, `/api/operacoes/${obj_new_atividade?.id_operacao}`);
      lista_de_atividade.splice(lista_de_atividade.findIndex((atividade) => atividade.id_operacao === obj_new_atividade?.id_operacao), 1);
      set_obj_new_atividade(undefined);
      set_open_dialog_tem_a_certeza_que_quer_eliminar_atividade(false);
      setMessage(operacao_sucesso);
      setOpenSnackSuccess(true);
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_atividade", error, true);
      setIsLoading(false);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage(operacao_erro);
      }
      setOpenSnackError(true);
    }
  }


  return (
    <CustomThemeProvider>
      <Snackbar
        open={openSnackSuccess}
        autoHideDuration={2000}
        onClose={() => setOpenSnackSuccess(false)}
      >
        <Alert
          onClose={() => setOpenSnackSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackError}
        autoHideDuration={2000}
        onClose={() => setOpenSnackError(false)}
      >
        <Alert
          onClose={() => setOpenSnackError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}

        </Alert>
      </Snackbar>

      {
        flag_open_modal_atividade === true &&
        <Modaladdatividade
          lista={lista_de_atividade}
          flag_open_modal={flag_open_modal_atividade}
          set_flag_open_modal={set_flag_open_modal_atividade}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_lista={set_lista_de_atividade}
          flag_open_modal_ver_mais={flag_open_modal_atividade_ver_mais}
          set_flag_open_modal_ver_mais={set_flag_open_modal_atividade_ver_mais}
          flag_open_modal_edit={flag_open_modal_atividade_edit}
          set_flag_open_modal_edit={set_flag_open_modal_atividade_edit}
          flag_open_modal_add={flag_open_modal_atividade_add}
          set_flag_open_modal_add={set_flag_open_modal_atividade_add}
          set_obj_new={set_obj_new_atividade}
          obj_new={obj_new_atividade}
          lista_financeiro={lista_de_financeiro}

        />
      }

      {
        flag_open_modal_atividade_ver_mais === true &&
        <Modalveratividade
          flag_open_modal={flag_open_modal_atividade}
          set_flag_open_modal={set_flag_open_modal_atividade}
          obj_new={obj_new_atividade}
          flag_open_modal_ver_mais={flag_open_modal_atividade_ver_mais}
          set_flag_open_modal_ver_mais={set_flag_open_modal_atividade_ver_mais}
          lista_financeiro={lista_de_financeiro}

        />
      }
      {
        flag_open_modal_trabalhadores === true &&
        <Modalverlistatrabalhador
          list={lista_de_trabalhadores}
          list_aux={lista_de_trabalhadores_aux}
          flag_open_modal={flag_open_modal_trabalhadores}
          set_flag_open_modal={set_flag_open_modal_trabalhadores}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list={set_lista_de_trabalhadores}
          obj_atividade={obj_new_atividade}
          set_obj_new_atividade={set_obj_new_atividade}
        />
      }

      {
        flag_open_modal_maquinas === true &&
        <Modalverlistamaquina
          list={lista_de_maquinas}
          list_aux={lista_de_maquinas_aux}
          flag_open_modal={flag_open_modal_maquinas}
          set_flag_open_modal={set_flag_open_modal_maquinas}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list={set_lista_de_maquinas}
          obj_atividade={obj_new_atividade}
          set_obj_new_atividade={set_obj_new_atividade}

        />
      }

      {
        flag_open_modal_checklist === true &&
        <Modalverlistachecklist
          list_aux={[]}
          list={lista_de_checklist}
          flag_open_modal={flag_open_modal_checklist}
          set_flag_open_modal={set_flag_open_modal_checklist}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list={set_lista_de_checklist}
          obj_atividade={obj_new_atividade}
          set_obj_new_atividade={set_obj_new_atividade}

        />
      }



      <div className={classes.root}>
        <HomeViewTecnico title=" Atividade" />

        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <div className={`${classes.label} p-4`}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1
            }}>

              {
                isLoading === true ?
                  loader() :
                  <div className="p-5">
                    <button
                      type="button"
                      onClick={() => {
                        set_flag_open_modal_atividade(true);
                        set_flag_open_modal_atividade_edit(true);
                        set_flag_open_modal_atividade_add(true);
                        set_obj_new_atividade(undefined)

                      }}
                      className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                    >
                      <AddIcon sx={{ fontSize: 18 }} />
                      Adicionar Registo Atividade
                    </button>
                  </div>
              }

              <div style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {
                  lista_de_atividade.length === 0 ?

                    <div style={{}}
                      className="flex flex-col items-center gap-3"
                    >
                      <p className="text-gray-500 text-lg">Sem Atividades registadas</p>
                    </div>
                    :
                    lista_de_atividade.length > 0 ?

                      <div className="flex flex-wrap gap-4">
                        {lista_de_atividade.map((atividade, key) => {
                          return (
                            <div
                              key={key}
                              className="w-[200px] rounded-2xl border border-gray-200 bg-stone-50 p-4 shadow-sm"
                            >
                              <div className="space-y-2 text-sm">
                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Tipo Atividade</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.tipo_operacao}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Fase Produção</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.fase_producao}
                                  </span>
                                </div>

                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Data Início</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.data_inicio ? new Date(atividade.data_inicio).toLocaleDateString() : '-'}
                                  </span>
                                </div>


                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Data Fim</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.data_fim ? new Date(atividade.data_fim).toLocaleDateString() : '-'}
                                  </span>
                                </div>


                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Estado</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.estado}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Prioridade</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.prioridade}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Custo Estimado</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.custo_estimado !== null && atividade.custo_estimado !== undefined ? `${atividade.custo_estimado} €` : '-'}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Custo Real</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.custo_real !== null && atividade.custo_real !== undefined ? `${atividade.custo_real} €` : '-'}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between gap-3">
                                  <span className="text-gray-500">Recorrente</span>
                                  <span className="text-gray-800 font-medium">
                                    {atividade.recorrente ? 'Sim' : 'Não'}
                                  </span>
                                </div>
                              </div>



                              <div className="flex justify-between gap-2 mt-4">
                                <button
                                  type="button"
                                  onClick={() => {

                                    set_flag_open_modal_atividade(true)
                                    set_flag_open_modal_atividade_ver_mais(true)
                                    set_obj_new_atividade(atividade)
                                  }}
                                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                >
                                  <VisibilityIcon sx={{ fontSize: 18 }} />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    set_flag_open_modal_atividade(true)
                                    set_obj_new_atividade(atividade)
                                    set_flag_open_modal_atividade_edit(true)

                                  }}
                                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                >
                                  <EditIcon sx={{ fontSize: 18 }} />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    set_open_dialog_tem_a_certeza_que_quer_eliminar_atividade(true)
                                    set_obj_new_atividade(atividade)

                                  }}
                                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                >
                                  <DeleteIcon sx={{ fontSize: 18 }} />
                                </button>

                              </div>

                              <div className="grid grid-cols gap-2 pt-2">
                                <button
                                  type="button"
                                  onClick={() => {
                                    // abrir modal de custos

                                    if (atividade.id_operacao !== obj_new_atividade?.id_operacao || obj_new_atividade?.id_operacao === undefined || atividade.id_operacao === undefined) {


                                      get_info_operacoes(atividade.id_operacao).then((res) => {
                                        if (res) {
                                          set_obj_new_atividade(res);
                                          set_lista_de_trabalhadores(res.trabalhadores);
                                          set_flag_open_modal_trabalhadores(true);
                                        } else {
                                          setMessage(operacao_erro);
                                          setOpenSnackError(true);
                                        }
                                      })
                                    } else {
                                      set_lista_de_trabalhadores(obj_new_atividade?.trabalhadores || []);
                                      set_flag_open_modal_trabalhadores(true);
                                    }
                                  }}
                                  className="flex items-center justify-center rounded-xl px-3 py-2.5 text-sm font-medium text-[#c94f1e] bg-orange-50 border border-orange-200 hover:bg-orange-100 transition-colors"
                                >
                                  Trabalhadores
                                </button>

                                <button
                                  type="button"
                                  onClick={() => {
                                    // abrir modal de receitas
                                    if (atividade.id_operacao !== obj_new_atividade?.id_operacao || obj_new_atividade?.id_operacao === undefined || atividade.id_operacao === undefined) {


                                      get_info_operacoes(atividade.id_operacao).then((res) => {
                                        if (res) {
                                          set_obj_new_atividade(res);
                                          set_lista_de_maquinas(res.receitas);
                                          set_flag_open_modal_maquinas(true);
                                        } else {
                                          setMessage(operacao_erro);
                                          setOpenSnackError(true);
                                        }
                                      })
                                    } else {
                                      set_lista_de_maquinas(obj_new_atividade?.maquinas || []);
                                      set_flag_open_modal_maquinas(true);
                                    }
                                  }}
                                  className="flex items-center justify-center rounded-xl px-3 py-2.5 text-sm font-medium text-green-700 bg-green-50 border border-green-200 hover:bg-green-100 transition-colors"
                                >
                                  Máquinas
                                </button>

                                <button
                                  type="button"
                                  onClick={() => {


                                    if (atividade.id_operacao !== obj_new_atividade?.id_operacao || obj_new_atividade?.id_operacao === undefined || atividade.id_operacao === undefined) {
                                      get_info_operacoes(atividade.id_operacao).then((res) => {
                                        if (res) {
                                          set_obj_new_atividade(res);
                                          set_lista_de_checklist(res.checklist);
                                          set_flag_open_modal_checklist(true);
                                        } else {
                                          setMessage(operacao_erro);
                                          setOpenSnackError(true);
                                        }
                                      })
                                    } else {
                                      set_lista_de_checklist(obj_new_atividade?.checklist || []);
                                      set_flag_open_modal_checklist(true);
                                    }
                                  }}
                                  className="flex items-center justify-center rounded-xl px-3 py-2.5 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 hover:bg-blue-100 transition-colors"
                                >
                                  Checklist
                                </button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                      : <></>
                }



              </div>



            </div>



          </div>
        </main>
      </div>



      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar_atividade}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_atividade(false)}
        onConfirm={handle_delete_atividade}
        message="Deseja eliminar o registo?"
      />

    </CustomThemeProvider>
  )



}

export default Atividade;
